import { Select, DatePicker, Input, Row, Col } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { isAuthenticated } from "../../../commons/Auth/auth";
import { Error, Success } from "../../../commons/Messages/Messages";
import { dealStages } from "../../../utils/dealStages";
import { prioritiesArray } from "../../../utils/prioritiesArray";
import GeneralModal from "../General.modal";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";

const { TextArea } = Input;

const onChangetab = key => {};

const AddDeal = ({ updateParent }) => {
  const { t } = useTranslation("dashboard");
  const [employeesArray, setEmployeesArray] = useState([]);
  const [dealData, setDealData] = useState({
    employee: "",
    serviceProvider: isAuthenticated()?.serviceProviderId,
    title: "",
    value: "",
    client: "",
    stage: "",
    priority: "",
    status: "",
    startDate: "",
    closedDate: "",
    description: "",
    notes: ""
  });

  const { Title } = Typography;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = async e => {
    if (!dealData.startDate || !dealData.closedDate || !dealData.description) {
      Error("Please fill in all required fields.");
      return;
    }
    await axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/deal/add`, dealData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          updateParent();
          handleCancel();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        if (err?.response && err?.response?.data && err?.response?.data?.errors) {
          const validationErrors = err?.response?.data?.errors;
          const errorMessage = Object.values(validationErrors)
            ?.map(err => `${err?.path} is ${err?.kind}.`)
            .join("\n");
          Error(errorMessage);
        } else if (err?.response?.data?.keyPattern) {
          Error(Object.keys(err?.response?.data?.keyPattern) + " already exists");
        } else {
          Error(err.message);
        }
      });
  };

  const getData = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/employees/employee/creator/${isAuthenticated()?.serviceProviderId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          let makeOptions = res.data?.map(d => ({
            label: d?.firstName + " " + d?.lastName,
            value: d?._id
          }));
          setEmployeesArray(makeOptions);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        if (err.response?.data?.errorMessage) {
          Error(err.response?.data?.errorMessage);
        } else {
          Error(err.message);
        }
      });
  };

  useEffect(() => {
    getData();

    return () => {};
  }, []);

  const onInputChange = e => {
    setDealData({ ...dealData, [e.target.name]: e.target.value });
  };

  const dateChange = (field, value) => {
    setDealData({ ...dealData, [field]: value });
  };

  const onSelectChange = (field, value) => {
    setDealData({ ...dealData, [field]: value });
  };

  const items = (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={12}>
        <div className="form-group">
          <Title level={5}>
            {t("Stage")} <span className="text-danger">*</span>
          </Title>
          <Select
            className="w-100"
            onChange={val => onSelectChange("stage", val)}
            options={dealStages.map(a => ({ value: a, label: a }))}
            allowClear
            showSearch
            placeholder={t("select", { field: t("Stage") })}
          />
        </div>
      </Col>
      <Col xs={24} md={12}>
        <div className="form-group">
          <Title level={5}>
            {t("Taken By Employee")} <span className="text-danger">*</span>
          </Title>
          <Select
            className="w-100"
            onChange={val => onSelectChange("employee", val)}
            options={employeesArray}
            allowClear
            showSearch
            placeholder={t("select", { field: t("employee") })}
          />
        </div>
      </Col>
      <Col xs={24} md={12}>
        <div className="form-group">
          <Title level={5}>
            {t("Client")} <span className="text-danger">*</span>
          </Title>
          <Input
            name="client"
            onChange={onInputChange}
            placeholder={t("enter", { field: t("Client") })}
          />
        </div>
      </Col>
      <Col xs={24} md={12}>
        <div className="form-group">
          <Title level={5}>{t("Value")}</Title>
          <Input
            type="number"
            name="value"
            onChange={onInputChange}
            placeholder={t("enter", { field: t("Value") })}
          />
        </div>
      </Col>
      <Col xs={24} md={12}>
        <div className="form-group">
          <Title level={5}>{t("Start Date")}</Title>
          <DatePicker
            onChange={(d, ds) => dateChange("startDate", ds)}
            className="w-100"
            placeholder={t("enter", { field: t("Start Date") })}
            format={"DD/MMM/YYYY"}
          />
        </div>
      </Col>
      <Col xs={24} md={12}>
        <div className="form-group">
          <Title level={5}>{t("Closed Date")}</Title>
          <DatePicker
            onChange={(d, ds) => dateChange("closedDate", ds)}
            className="w-100"
            placeholder={t("enter", { field: t("Closed Date") })}
            format={"DD/MMM/YYYY"}
          />
        </div>
      </Col>
      <Col xs={24} md={12}>
        <div className="form-group">
          <Title level={5}>{t("Priority")}</Title>
          <Select
            className="w-100"
            onChange={val => onSelectChange("priority", val)}
            options={prioritiesArray.map(a => ({ value: a, label: a }))}
            allowClear
            showSearch
            placeholder={t("select", { field: t("Priority") })}
          />
        </div>
      </Col>
      <Col xs={24} md={12}>
        <div className="form-group">
          <Title level={5}>{t("Tags")}</Title>
          <Select
            mode="tags"
            className="w-100"
            onChange={val => onSelectChange("tags", val)}
            allowClear
            showSearch
            placeholder={t("select", { field: t("Tags") })}
          />
        </div>
      </Col>
      <Col xs={24}>
        <div className="form-group">
          <Title level={5}>{t("Description")}</Title>
          <TextArea
            name="description"
            onChange={onInputChange}
            rows={4}
            placeholder={t("enter", { field: t("Description") })}
          />
        </div>
      </Col>
      <Col xs={24}>
        <div className="form-group">
          <Title level={5}>{t("Notes")}</Title>
          <TextArea
            name="notes"
            onChange={onInputChange}
            rows={2}
            placeholder={t("enter", { field: t("Notes") })}
          />
        </div>
      </Col>
    </Row>
  );

  return (
    <div className="AddDeal">
      <MainButtonComp text="Add Deals" addBtn onClick={showModal} />
      <GeneralModal
        title={t("Add Deal")}
        onOk={() => onSubmit()}
        open={isModalOpen}
        okText={t("Save")}
        onCancel={handleCancel}
        onChange={onChangetab}
        items={items}
      />
    </div>
  );
};

export default AddDeal;
